document.addEventListener('DOMContentLoaded', function () {

    let btns = document.getElementsByClassName('btn-delete');

    for (let i = 0; i < btns.length; i++) {
        btns[i].onclick = function (e) {
            if (!confirm('Do you really want to delete this item?')) {
                e.preventDefault();
                btns[i].blur();
            }
        }
    }

});
